import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/index';
import HeaderSticky from '../HeaderSticky';
import NewAvatarHeader from '../NewAvatarHeader';
import ApproveRenewPhotos from '../ApproveRenewPhotos';
import PhotoStyles from '../PhotoStyles';
import Feedbacks from '../Feedbacks';
import Customers from '../Customers';
import Schedules from '../Schedules';
import PhotoCarts from '../PhotoCarts';
import ManagePhotoPacks from '../ManagePhotoPacks';

const WARNING_ICON = (
  <svg fill="currentColor" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.001 10h2v5h-2zM11 16h2v2h-2z" />
    <path d="M13.768 4.2C13.42 3.545 12.742 3.138 12 3.138s-1.42.407-1.768 1.063L2.894 18.064a1.986 1.986 0 0 0 .054 1.968A1.984 1.984 0 0 0 4.661 21h14.678c.708 0 1.349-.362 1.714-.968a1.989 1.989 0 0 0 .054-1.968L13.768 4.2zM4.661 19 12 5.137 19.344 19H4.661z" />
  </svg>
);

const ASSETS_ICON = (
  <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3,11h7a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3v7A1,1,0,0,0,3,11ZM4,4H9V9H4ZM22,3a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1ZM20,9H15V4h5ZM2,21a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V14a1,1,0,0,0-1-1H3a1,1,0,0,0-1,1Zm2-6H9v5H4Zm18,6V14a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h7A1,1,0,0,0,22,21Zm-2-1H15V15h5Z" />
  </svg>
);

const SECTIONS = [
  { id: 'customers', label: 'Customers', Component: Customers },
  { id: 'photoPacks', label: 'Photo Packs', Component: ManagePhotoPacks },
  { id: 'photoStyles', label: 'Photo Styles', Component: PhotoStyles },
  { id: 'photoCarts', label: 'Headshot Orders', Component: PhotoCarts },
  { id: 'renew', label: 'Approve Renew Photos', Component: ApproveRenewPhotos },
  { id: 'feedbacks', label: 'Feedbacks', Component: Feedbacks },
  { id: 'schedules', label: 'Schedules', Component: Schedules },
];

const panelProps = (firebase, userData, t, onFetchUser) => ({
  firebase,
  userData,
  t,
  onFetchUser,
  isCreating: false,
});

const AdminDashboard = ({ firebase, userData, onFetchUser }) => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('customers');
  const currentLanguage = i18n.language || 'en';
  const appPath = currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`;

  const ActivePanel = SECTIONS.find((section) => section.id === activeSection)?.Component || Customers;

  const onSelectSection = (event, sectionId) => {
    event.preventDefault();
    setActiveSection(sectionId);
  };

  return (
    <div style={{ background: '#111', minHeight: '100vh' }}>
      {userData && (
        <>
          <div className="left-area" id="scroll-top-nav">
            <div className="logo-header-desk">
              <HeaderSticky
                currentLanguage={currentLanguage}
                isMobile={false}
                isActiveMobileMenu={false}
                openMobileMenu={() => {}}
                onActiveProfessional={() => {}}
                darkMode
              />
            </div>
            <div className="nav-wrapper">
              <div className="nav-menu">
                {SECTIONS.map((section) => (
                  <a
                    key={section.id}
                    href="#"
                    className={`nav-link${activeSection === section.id ? ' active' : ''}`}
                    onClick={(event) => onSelectSection(event, section.id)}
                  >
                    {WARNING_ICON}
                    <span>{section.label}</span>
                  </a>
                ))}
                <Link to={appPath} className="nav-link">
                  {ASSETS_ICON}
                  <span>Back to App</span>
                </Link>
              </div>
            </div>
            <div className="left-down-menu">
              <div className="dropdown">
                <NewAvatarHeader userData={userData} t={t} />
              </div>
            </div>
          </div>
          <div className="right-area">
            <ActivePanel {...panelProps(firebase, userData, t, onFetchUser)} />
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDashboard;
